export enum ERROR_TYPE {
	TOOLTIP,
	BLOCK
}
